// extracted by mini-css-extract-plugin
export default {"portraitContainer":"c4YKj_bz","head":"rfAUzAO1","landscapeContainer":"nZyFvDbE","sidebar":"mpB6taR7","main":"Sr6Y7sw5"};